import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2 {...{
      "id": "q1-2024-goals"
    }}>{`Q1 2024 Goals`}</h2>
    <h3 {...{
      "id": "-deploy-with-confidence"
    }}>{`💪 Deploy with confidence`}</h3>
    <p>{`Our deploy speed keeps us moving fast but bigger changes would benefit from better tooling to gradually roll out, validate and roll back if necessary.`}</p>
    <ul>
      <li parentName="ul">{`Auto rollbacks with orchestration / blocking new deploys`}</li>
      <li parentName="ul">{`Canary deployments`}</li>
      <li parentName="ul">{`Load testing`}</li>
      <li parentName="ul">{`Investigate something like envoy perhaps to enable traffic shadowing + canary deploys`}</li>
      <li parentName="ul">{`Finish helm charts work`}</li>
      <li parentName="ul">{`Anomaly detection`}</li>
    </ul>
    <h3 {...{
      "id": "-keep-costs-under-control"
    }}>{`💰 Keep costs under control`}</h3>
    <ul>
      <li parentName="ul">{`Keep on top of the great work so far to keep costs under control`}</li>
      <li parentName="ul">{`Tackle remaining clear improvements (Cloudfront costs, reserved instances etc.)`}</li>
      <li parentName="ul">{`Kafka ops work including tiered storage`}</li>
    </ul>
    <h3 {...{
      "id": "-yet-more-observability"
    }}>{`👀 Yet more Observability`}</h3>
    <ul>
      <li parentName="ul">{`CI/CD times (measuring it to know where the pain points are)`}</li>
      <li parentName="ul">{`Cost of resources per product `}</li>
      <li parentName="ul">{`Get tracing solution firmly into the hands and minds of teams`}</li>
    </ul>
    <h3 {...{
      "id": "-security-as-a-feature"
    }}>{`🎯 Security as a feature`}</h3>
    <ul>
      <li parentName="ul">{`Investigate pragmatic parts of SOC 2 type II we could already be moving towards`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      